import { Modal, PrimaryButton, SecondaryButton } from '@systemeio/ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

type ModalConfirmationProps = {
  isOpen: boolean
  handleClose: () => void
  closeVisible?: boolean
  confirmationText: string
  handleExit: () => void
  isLoading?: boolean
  handleSave: () => void
}

const ModalConfirmation = ({
  handleClose,
  isOpen,
  confirmationText,
  handleExit,
  isLoading,
  handleSave,
}: ModalConfirmationProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      isCentered
      title={t('confirmation_modal.default_title')}
      onClose={handleClose}
      opened={isOpen}
    >
      <form className="flex flex-col gap-6 lg:gap-10">
        <div className="flex justify-center">
          <p className="text-text-primary text-base">{confirmationText}</p>
        </div>
        <div className="flex justify-center gap-4">
          <SecondaryButton
            type="button"
            className={`w-full`}
            width="large"
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault()
              handleExit()
            }}
            disabled={isLoading}
          >
            {t('confirmation_modal.cancel')}
          </SecondaryButton>
          <PrimaryButton
            type="submit"
            isFetching={isLoading}
            className={`w-full`}
            width="large"
            onClick={async (e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault()
              await handleSave()
            }}
          >
            {t('confirmation_modal.confirm')}
          </PrimaryButton>
        </div>
      </form>
    </Modal>
  )
}

export default ModalConfirmation
